import { InjectionToken, Provider } from '@angular/core';
import { Settings } from './models';
import { SettingsDataService } from './settings-data.service';

export const APP_SETTINGS = new InjectionToken<Settings>('APP_SETTINGS');

export const APP_SETTINGS_PROVIDER: Provider = {
  provide: APP_SETTINGS,
  deps: [SettingsDataService],
  useFactory: (service: SettingsDataService) => {
    if (!service.settings) {
      throw new Error('Settings not fetched. Guard your routes');
    }

    return service.settings;
  }
};
